/* eslint-disable no-restricted-globals */

const currentHostname = location.hostname;
const contentHostname = currentHostname.includes("coach")
    ? currentHostname.replace("coach", "content")
    : currentHostname;

const uploadsBaseUrl = currentHostname.includes("coach")
    ? `${location.protocol}//${contentHostname}`
    : `${location.protocol}//${currentHostname}:1337`;

export const getUploadUrl = (file: string) => `${uploadsBaseUrl}/uploads/${file}`;
